/* SamiXTrade: progressive enhancement. Native product/cart forms work without JavaScript. */
(() => {
  'use strict';
  const strings = JSON.parse(document.getElementById('EnginoraTranslations')?.textContent || '{}');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousels = new WeakMap();
  const closestSlideIndex = (track, slides) => {
    const target = track.getBoundingClientRect().left + track.clientWidth / 2;
    let best=0, distance=Infinity;
    slides.forEach((slide,index) => {
      const bounds=slide.getBoundingClientRect();
      const current=Math.abs(bounds.left+bounds.width/2-target);
      if(current<distance){distance=current;best=index;}
    });
    return best;
  };
  function initCarousel(section) {
    if(carousels.has(section)) return;
    const track=section.querySelector('[data-carousel-track]');
    if(!track) return;
    const slides=Array.from(track.children);
    const dots=Array.from(section.querySelectorAll('[data-carousel-dot]'));
    if(slides.length<2) return;
    const pause=section.querySelector('[data-carousel-pause]');
    let index=0, timer, frame, hovered=false, focused=false, visible=true;
    let paused=reducedMotion.matches;
    const updateDots=() => dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
    const stop=()=>window.clearTimeout(timer);
    const schedule=()=>{
      stop();
      if(!section.isConnected||section.dataset.autoplay!=='true'||paused||hovered||focused||!visible||document.hidden||reducedMotion.matches)return;
      timer=window.setTimeout(()=>go(index+1,false),Math.max(3000,Number(section.dataset.delay)||5000));
    };
    function go(target,manual=true){
      index=(target+slides.length)%slides.length;
      const bounds=track.getBoundingClientRect();
      const destination=slides[index].getBoundingClientRect().left-bounds.left+track.scrollLeft;
      track.scrollTo({left:destination,behavior:reducedMotion.matches?'auto':'smooth'});
      updateDots();
      if(manual) stop();
      schedule();
    }
    const updatePause=()=>{
      if(!pause)return;
      pause.setAttribute('aria-pressed',String(paused));
      pause.textContent=paused?strings.carouselPlay:strings.carouselPause;
    };
    section.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>go(index-1));
    section.querySelector('[data-carousel-next]')?.addEventListener('click',()=>go(index+1));
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
    pause?.addEventListener('click',()=>{paused=!paused;updatePause();schedule();});
    track.addEventListener('scroll',()=>{
      window.cancelAnimationFrame(frame);
      frame=window.requestAnimationFrame(()=>{index=closestSlideIndex(track,slides);updateDots();});
    },{passive:true});
    track.addEventListener('pointerdown',stop,{passive:true});
    track.addEventListener('pointerup',schedule,{passive:true});
    track.addEventListener('touchstart',stop,{passive:true});
    track.addEventListener('touchend',schedule,{passive:true});
    track.addEventListener('keydown',event=>{
      if(event.target!==track)return;
      if(event.key==='ArrowRight'){event.preventDefault();go(index+1);}
      if(event.key==='ArrowLeft'){event.preventDefault();go(index-1);}
      if(event.key==='Home'){event.preventDefault();go(0);}
      if(event.key==='End'){event.preventDefault();go(slides.length-1);}
    });
    section.addEventListener('mouseenter',()=>{hovered=true;stop();});
    section.addEventListener('mouseleave',()=>{hovered=false;schedule();});
    section.addEventListener('focusin',()=>{focused=true;stop();});
    section.addEventListener('focusout',()=>{window.setTimeout(()=>{focused=section.contains(document.activeElement);schedule();},0);});
    const onVisibility=()=>schedule();
    const onReduced=()=>{if(reducedMotion.matches){paused=true;updatePause();}schedule();};
    document.addEventListener('visibilitychange',onVisibility);
    reducedMotion.addEventListener('change',onReduced);
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.1});
    observer.observe(section);
    carousels.set(section,()=>{stop();observer.disconnect();document.removeEventListener('visibilitychange',onVisibility);reducedMotion.removeEventListener('change',onReduced);});
    updatePause();updateDots();schedule();
  }
  function initProduct(section){
    if(section.dataset.initialized==='true')return;
    section.dataset.initialized='true';
    const selector=section.querySelector('[data-variant-select]');
    if(!selector)return;
    selector.addEventListener('change',()=>{
      const selected=selector.selectedOptions[0];
      if(!selected)return;
      const price=section.querySelector('[data-product-price]');
      const compare=section.querySelector('[data-product-compare]');
      const add=section.querySelector('[data-add-button]');
      const quantity=section.querySelector('input[name="quantity"]');
      const updateDisplayMoney=(container,cents,fallback)=>{
        if(!container)return;
        const money=container.querySelector('[data-display-money]');
        if(money){money.dataset.moneyCents=cents||'0';money.textContent=fallback||'';}
        else container.textContent=fallback||'';
      };
      updateDisplayMoney(price,selected.dataset.priceCents,selected.dataset.price);
      updateDisplayMoney(compare,selected.dataset.compareCents,selected.dataset.compare);
      if(compare)compare.hidden=!selected.dataset.compare;
      const monthlyNote=section.querySelector('[data-monitor-monthly]');
      if(monthlyNote){
        monthlyNote.hidden=!selected.dataset.monthlyPriceCents;
        updateDisplayMoney(monthlyNote.querySelector('[data-monitor-monthly-price]'),selected.dataset.monthlyPriceCents,selected.dataset.monthlyPrice);
      }
      document.dispatchEvent(new Event('enginora:prices-updated'));
      if(add){add.disabled=selected.dataset.available!=='true';(add.querySelector('[data-add-label]')||add).textContent=add.disabled?strings.unavailable:strings.addToCart;}
      if(quantity){
        quantity.min=selected.dataset.min||'1';quantity.step=selected.dataset.step||'1';
        if(selected.dataset.max)quantity.max=selected.dataset.max;else quantity.removeAttribute('max');
        quantity.value=quantity.min;
      }
      const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);
      window.history.replaceState({},'',url);
    });
  }
  function init(root=document){
    root.querySelectorAll('[data-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    const cartError=root.querySelector('#CartError');
    if(cartError){
      try{
        const previous=window.sessionStorage.getItem('samixCartError');
        if(previous){cartError.textContent=previous;cartError.hidden=false;cartError.tabIndex=-1;cartError.focus();window.sessionStorage.removeItem('samixCartError');}
      }catch(_exception){/* Storage may be unavailable; live request errors still render inline. */}
    }
  }
  document.addEventListener('click',event=>{
    const quantityButton=event.target.closest('[data-quantity-minus],[data-quantity-plus]');
    if(quantityButton){
      const input=quantityButton.closest('[data-quantity-control]')?.querySelector('input');
      if(input){
        if(!input.value||!Number.isFinite(Number(input.value)))input.value=input.min||'1';
        quantityButton.hasAttribute('data-quantity-plus')?input.stepUp():input.stepDown();
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    document.querySelectorAll('.menu-disclosure[open]').forEach(menu=>{
      if(!menu.contains(event.target)||event.target.closest('.menu-panel a'))menu.open=false;
    });
    const thumb=event.target.closest('.product-thumbnails a');
    if(thumb){
      const target=document.getElementById(thumb.hash.slice(1));
      const track=target?.closest('.product-media-track');
      if(target&&track){event.preventDefault();track.scrollTo({left:target.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft,behavior:reducedMotion.matches?'auto':'smooth'});}
    }
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('.menu-disclosure[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});
  });
  document.addEventListener('focusout',event=>{
    const menu=event.target.closest('.menu-disclosure');
    if(menu?.open)window.setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},0);
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(form.matches('.cart-form')&&form.dataset.needsReload==='true'){event.preventDefault();window.location.assign(form.action);return;}
    if(!form.matches('.cart-form')||event.submitter?.name!=='update'||!window.fetch)return;
    event.preventDefault();
    const error=form.querySelector('#CartError');
    const button=event.submitter;const original=button.textContent;
    button.disabled=true;button.textContent=strings.cartUpdating;
    if(error){error.hidden=true;error.textContent='';}
    try{
      const request=async(action,payload)=>{
        const endpoint=new URL(form.action,window.location.origin);endpoint.pathname=endpoint.pathname.replace(/\/$/,'')+'/'+action+'.js';
        const response=await fetch(endpoint,{method:'POST',body:JSON.stringify(payload),headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'same-origin'});
        const result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:typeof result.message==='string'?result.message:strings.cartQuantityError);
        return result;
      };
      const changes=Array.from(form.querySelectorAll('[data-cart-line]')).filter(input=>Number(input.value)!==Number(input.dataset.originalQuantity)).reverse();
      // Descending line order keeps lower line positions stable when another line is removed.
      for(const input of changes)await request('change',{line:Number(input.dataset.cartLine),quantity:Number(input.value)});
      const note=form.querySelector('[name="note"]');
      if(note)await request('update',{note:note.value});
      window.location.assign(form.action);
    }catch(exception){
      const message=exception instanceof TypeError?strings.cartConnectionError:exception.message||strings.cartUpdateError;
      // An earlier line may already have changed. Reload Shopify's current cart before a retry.
      try{window.sessionStorage.setItem('samixCartError',message);window.location.assign(form.action);return;}catch(_exception){/* Fallback below when storage is blocked. */}
      if(error){
        error.textContent=message+' ';
        const reload=document.createElement('a');reload.href=form.action;reload.textContent=strings.cartReload;
        error.appendChild(reload);error.hidden=false;error.tabIndex=-1;error.focus();
      }
      form.dataset.needsReload='true';
      button.disabled=false;button.textContent=original;
    }
  });
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-carousel]').forEach(section=>carousels.get(section)?.()));
})();
